// 짧게 떴다 사라지는 안내 토스트.
import { useEffect } from 'preact/hooks';

interface Props {
  message: string;
  onDone: () => void;
  duration?: number;
}

export function Toast({ message, onDone, duration = 2200 }: Props) {
  useEffect(() => {
    const t = setTimeout(onDone, duration);
    return () => clearTimeout(t);
  }, [message]);

  return <div class="toast" role="status">{message}</div>;
}
